import * as React from "react";
import { Grid } from "semantic-ui-react";
import { AppointmentModel } from "@teamprevent/common/appointment";

interface Props {
    appointment: AppointmentModel;
}

export class AppointmentTimelineRow extends React.Component<Props> {
    public render() {
        const { appointment } = this.props;
        return (
            <Grid.Row className="case-timeline-event">
                <Grid.Column mobile={16} computer={4}>{appointment.taskType}</Grid.Column>
                <Grid.Column mobile={16} computer={4}><strong>Date:</strong> {appointment.start.format("DD/MM/YY")}</Grid.Column>
                <Grid.Column mobile={16} computer={4}>
                    <strong>Time:</strong> {appointment.start.format("HH:mm")} - {appointment.end.format("HH:mm")}
                </Grid.Column>
                <Grid.Column mobile={16} computer={4}>{appointment.clinician && <><strong>Clinician:</strong> {appointment.clinician}</>}</Grid.Column>
                {appointment.locations && appointment.locations.map(l => (
                    <React.Fragment key={l.id}>
                        <Grid.Column mobile={16} computer={8}><strong>Address:</strong> {l.address}</Grid.Column>
                        <Grid.Column mobile={16} computer={8}><strong>Room:</strong> {l.roomName} ({l.notes})</Grid.Column>
                    </React.Fragment>
                ))}
            </Grid.Row>
        );
    }
}
